export enum BlacklistScope {
	PERSON = "PERSON",
	ORGANIZATION = "ORGANIZATION",
}

/**
 * What to take from an uploaded blacklist CSV. A row may name a person *and* their employer, and
 * importing both from a person-only file blocks whole companies — so the user picks explicitly.
 */
export enum BlacklistImportScope {
	PERSON = "PERSON",
	ORGANIZATION = "ORGANIZATION",
	BOTH = "BOTH",
}
